import React, { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import axios from "config/axios";
import CourseInstructorsView from "./CourseInstructorsView";
import FastRewindIcon from "@mui/icons-material/FastRewind";
import { Link } from "react-router-dom";

const CourseDetailView = ({ courseId }) => {
  const [courseDetails, setCourseDetails] = useState(null);
  const [assignedInstructors, setAssignedInstructors] = useState([]);
  const [courseCreator, setCourseCreator] = useState(null);
  const [instructorsViewModalOpen, setInstructorsViewModalOpen] =
    React.useState(false);

  const fetchAssignedInstructors = async (instructorIds) => {
    const instructorsDetails = [];

    try {
      for (const instructorId of instructorIds) {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/instructors/profiles/${instructorId}`
        );

        const instructorDetail = response.data.instructor;
        instructorsDetails.push(instructorDetail);
      }

      return instructorsDetails;
    } catch (error) {
      console.error("Error fetching instructor details:", error);
      return [];
    }
  };

  const getCourseCreator = async (creatorId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/auth/users/${creatorId}`
      );
      if (response.data.success) return response.data.user;
      return null;
    } catch (error) {
      console.error("Error fetching course creator:", error);
      return null;
    }
  };

  const handleViewCourseMap = async () => {
    try {
      if (!courseDetails?.courseMapFileId) {
        toast.error("No course map available");
        return;
      }

      const url = `${process.env.REACT_APP_BACKEND_URL}/api/courseMap/courses/${courseId}/course-map`;
      window.open(url, "_blank"); // opens PDF in a new tab
    } catch (error) {
      console.error("Failed to open course map:", error);
      toast.error("Failed to open course map");
    }
  };

  useEffect(() => {
    const fetchCourseDetails = async () => {
      try {
        //fetching course details
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/courses/course/${courseId}`
        );
        const course = response.data.course;
        setCourseDetails(course);

        //Fetching course instructors

        const assignedinstructors = await fetchAssignedInstructors(
          course.instructors
        );
        setAssignedInstructors(assignedinstructors);
        //Fetching course creator
        const creator = await getCourseCreator(course.creatorId);
        setCourseCreator(creator);
      } catch (error) {
        console.error("Error:", error);
        return { success: false };
      }
    };

    fetchCourseDetails();
  }, []);

  return (
    <div className="bg-white flex flex-col justify-center items-center">
      <h2 className="text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight">
        Course Details
      </h2>

      <div className="rounded shadow-lg w-4/5">
        <div className="px-6 py-4 flex flex-col md:flex-row items-center justify-between border-b">
          <div className="w-full p-4 sm:p-6 flex flex-col md:flex-row sm:flex-wrap sm:items-center items-start justify-start gap-4 sm:gap-8">
            {courseDetails && (
              <div className="font-semibold text-base sm:text-lg md:text-xl sm:mb-0 break-words w-full sm:w-auto">
                <span className="block sm:inline font-bold">Course Title:</span>{" "}
                <span className="break-words">{courseDetails.title}</span>
              </div>
            )}

            {courseCreator && (
              <div className="font-semibold text-base sm:text-lg md:text-xl italic break-words w-full sm:w-auto">
                <span className="block sm:inline font-bold">Creator:</span>{" "}
                <span className="text-green-600 break-all">
                  {courseCreator.email}
                </span>
              </div>
            )}
          </div>

          <div className="flex items-center justify-end gap-2">
            {/* View Instructors */}
            <button
              className="bg-green-500 hover:bg-green-400 text-white font-bold py-2 px-4 border-b-4 border-green-700 hover:border-green-500 rounded"
              onClick={() => setInstructorsViewModalOpen(true)}
            >
              View Instructors
            </button>

            <CourseInstructorsView
              assignedInstructors={assignedInstructors}
              instructorsViewModalOpen={instructorsViewModalOpen}
              setInstructorsViewModalOpen={setInstructorsViewModalOpen}
            />

            {/* View Course Map */}
            {courseDetails?.courseMapFileId && (
              <button
                className="bg-blue-500 hover:bg-blue-400 text-white font-bold py-2 px-4 border-b-4 border-blue-700 hover:border-blue-500 rounded"
                onClick={handleViewCourseMap}
              >
                View Course PDF
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CourseDetailView;
